// src/components/AppComponents/NavBar/NavBarSources.ts

export const NAVBAR_SOURCES = {
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  createPassword: '/create-password',
  ssoTransfer: '/sso-transfer',
  settings: '/settings',
  dashboard: '/dashboard',
  kyc: '/kyc',
  commissions: '/funding/commissions',
  revenues: '/funding/revenues',
  invoicesLedger: '/funding/advances-ledger',
  activity: '/funding/activity',
  documents: '/funding/documents',
  fundingRules: '/revenue-sources/funding-rules',
  commercialTerms: '/revenue-sources/commercial-terms',
  businessDetails: '/account/business-details',
  users: '/account/users',
  bankAccounts: '/account/bank-accounts',
  guest: '/under-review',
};
